import { stripBase } from "./basePath";

export const stripHostFromNotificationUrl = (url) => {
  if (!url) return "";
  try {
    const parsed = new URL(url);
    return stripBase(parsed.pathname) + parsed.search + parsed.hash;
  } catch {
    return url.startsWith("/") ? stripBase(url) : "";
  }
};
